module.exports = __webpack_public_path__ + "img/pac.3b2df168.svg";